import React from "react"
import { useSelector } from "react-redux";
import { withSwal } from "react-sweetalert2";
import SEO from "../../elements/SEO";
import MainCard from "../../elements/MainCard";
import JobDetail from "../../molecules/job/jobDetail";
import Layout from "../layout/layout";

import '../layout/styles.scss';

const JobDetailPage = ({...props}) => {
  const { skills } = useSelector((state) => {
    return {
      skills: state?.skills?.skills || [],
    }
  });
  return (
    <Layout>
      <MainCard style={{ borderRadius: '12px', maxWidth: '1358px', margin: '0px auto' }}>
        <SEO title="Job details" />
        <div className="layout-container">
          <JobDetail
            {...props}
            skills={skills}
          />
        </div>
      </MainCard>
    </Layout>
  );
};

export default withSwal(JobDetailPage);
